import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ kicker, title, lead, dark = false }) => (
    <div className="max-w-3xl">
        <Reveal>
            <p
                className={`text-xs sm:text-sm font-bold uppercase tracking-[0.22em] ${
                    dark ? "text-tang" : "text-ink"
                }`}
            >
                {kicker}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-balance leading-[1.08] ${
                    dark ? "text-white" : "text-ink"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {lead && (
            <Reveal delay={0.16}>
                <p
                    className={`mt-5 text-base md:text-lg leading-relaxed ${
                        dark ? "text-white/70" : "text-ink-mute"
                    }`}
                >
                    {lead}
                </p>
            </Reveal>
        )}
    </div>
);
